import api from './Api';

export default {
  getTimes() {
    return api().get('schedule');
  }
};
